import { baseApi } from './base';
import type { 
  LoginRequest, 
  LoginResponse, 
  SignupRequest, 
  SignupResponse, 
  User, 
  ResetPasswordConfirmRequest, 
  SetPasswordRequest, 
  ForgotPasswordRequest, 
  ForgotPasswordResponse 
} from '@/types/auth';

export const authService = {
  async login(data: LoginRequest): Promise<LoginResponse> {
    return baseApi.request<LoginResponse>(
      '/auth/jwt/create/',
      {
        method: 'POST',
        body: JSON.stringify(data),
      },
      true
    );
  },

  async me(): Promise<User> {
    return baseApi.request<User>('/auth/users/me/');
  },

  async updateMe(data: Partial<User>): Promise<User> {
    return baseApi.request<User>('/auth/users/me/', {
      method: 'PATCH',
      body: JSON.stringify(data),
    });
  },

  async signup(data: SignupRequest): Promise<SignupResponse> {
    return baseApi.request<SignupResponse>(
      '/auth/users/',
      {
        method: 'POST',
        body: JSON.stringify(data),
      },
      true
    );
  },

  async activate(uid: string, token: string): Promise<void> {
    return baseApi.request<void>(
      '/auth/users/activation/',
      {
        method: 'POST',
        body: JSON.stringify({ uid, token }),
      },
      true
    );
  },

  async resendActivation(email: string): Promise<void> {
    return baseApi.request<void>(
      '/auth/resend-activation/',
      {
        method: 'POST',
        body: JSON.stringify({ email }),
      },
      true
    );
  },

  async forgotPassword(
    data: ForgotPasswordRequest
  ): Promise<ForgotPasswordResponse> {
    return baseApi.request<ForgotPasswordResponse>(
      '/auth/users/reset_password/',
      {
        method: 'POST',
        body: JSON.stringify(data),
      },
      true
    );
  },

  async resetPasswordConfirm(
    data: ResetPasswordConfirmRequest
  ): Promise<void> {
    return baseApi.request<void>(
      '/auth/users/reset_password_confirm/',
      {
        method: 'POST',
        body: JSON.stringify(data),
      },
      true
    );
  },

  async setPassword(data: SetPasswordRequest): Promise<void> {
    return baseApi.request<void>(
      '/auth/users/set_password/',
      {
        method: 'POST',
        body: JSON.stringify(data),
      }
    );
  },

  async logout(refresh: string): Promise<void> {
    return baseApi.request<void>(
      '/auth/jwt/logout/',
      {
        method: 'POST',
        body: JSON.stringify({ refresh }),
      }
    );
  },
};
